import React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import NavigationBarPlanner from '../../../components/NavigationBarPlanner.component'
import MainMenu from './MainMenu'
import ProjectDetail from './ProjectDetail'
import PrivateRoute from '../../../routes/PrivateRoute'
import ErrorPage from '../../ErrorPage'
import SEO from '../../SEO'
import { connect } from 'react-redux'
// import ProjectPlanner from './ProjectPlanner'

const DashboardPlanner = ({role}) => {
    return (
      <>
        {role === "planner" ? (
          <>
            <SEO
              title="Planner"
              description="Project List"
              content="Project List"
            />
            <NavigationBarPlanner notPlanner={true} />
            <Switch>
              <Route exact path="/dashboard/planner/">
                <Redirect to="/dashboard/planner/project-list" />
              </Route>
              <Route exact path="/dashboard/planner/project-list">
                <MainMenu />
              </Route>
              <Route path="/dashboard/planner/project-list/:id">
                <ProjectDetail />
              </Route>
              <Route path="*" component={ErrorPage} />
            </Switch>{" "}
          </>
        ) : (
          <>
            <ErrorPage />
          </>
        )}
      </>
    );
}

const mapStateToProps = state => {
  return {
    role: state.login.role
  }
}

export default connect(mapStateToProps, null)(DashboardPlanner)